import { ShakaLoadError } from "../player.types";
import { isShakaError } from "./is-shaka-error";

export function isLoadInterruptedError(e: unknown): e is ShakaLoadError {
  return isShakaError(e) && e.code === 7000;
}
